/* eslint-disable no-unused-vars */
const THREE = window.THREE;
import $ from 'jquery';
import store from '@/store';
import { initProj4, loadScript } from './forgeService'
import {
    getForgeToken,
    rotateViewerCamera,
    getViewerCurrentPdfPagesCount,
} from '../../utils/forgeUtils'
import { saveState } from '../../utils/mongoUtils'
import appConfig from '../../../appConfig'
const Autodesk = window.Autodesk;

export function launchViewer(urn, dispose3DOnly) {
    store.state.currentUrn = urn;
    initProj4();

    $('.clickoff').css('width', '100%');
    $('.clickoff').css('height', '100%');
    if (store.state.viewer) {
        if (dispose3DOnly)
            dispose3DViewer();
        else
            disposeForgeViewers();
    }
    store.state.mainUrn = urn;
    var options = {
        getAccessToken: getForgeToken,
        env: 'AutodeskProduction2',
        api: 'streamingV2', //or streamingV2_EU if in EMEA region 
    };
    var config = {
        skipPropertyDb: true,
        extensions: ['Autodesk.BimWalk', 'Autodesk.Snapping', 'Autodesk.DocumentBrowser'],
        disabledExtensions: {
            measure: true,
            section: true,
        },
    };

    // config["loaderExtensions"] = { svf: "Autodesk.MemoryLimited" };
    // config["memory"] = {
    //     limit: 4024,
    //     debug: {
    //         force: true
    //     }
    // }

    Autodesk.Viewing.Initializer(options, () => {

        let htmlDiv = document.getElementById('forgeViewer')
        store.state.viewer = new Autodesk.Viewing.GuiViewer3D(htmlDiv, config);

        store.state.viewer.loadExtension('MainExtension');
        store.state.viewer.loadExtension('TouchSelectionExtension');
        store.state.viewer.loadExtension('MeasurementExtension');
        store.state.viewer.loadExtension('Cropping3DExtension');
        store.state.viewer.loadExtension('ScaffoldBoxExtension');
        store.state.viewer.start();

        //Change Forge logo to Reality logo
        $('.forge-spinner img').attr('src', require(`@/images/RealityLoader.png`));
        Autodesk.Viewing.Document.load('urn:' + urn, onDocumentLoadSuccess, onDocumentLoadFailure);
    });
}
export function launchPlanViewer(urn) {
    store.commit('hideThumbnailPopup', '2d');
    dispose2DViewer();
    if (!urn)
        return;

    var options = {
        getAccessToken: getForgeToken,
        env: 'AutodeskProduction2',
        api: 'streamingV2',//or streamingV2_EU if in EMEA region 
    };
    store.state.planUrn = urn;
    Autodesk.Viewing.Initializer(options, () => {

        var DOMContent = document.getElementById('forge-plan-viewer-content');
        store.state.planViewer = new Autodesk.Viewing.GuiViewer3D(DOMContent, { disabledExtensions: { measure: true } });

        store.state.planViewer.start();
        $('.forge-spinner img').attr('src', require(`@/images/RealityLoader.png`));
        Autodesk.Viewing.Document.load("urn:" + urn, (doc) => {
            var defGeo = doc.getRoot().getDefaultGeometry();
            store.state.planViewer.loadDocumentNode(doc, defGeo).then(() => {
                store.state.planViewer.setBackgroundColor(255, 255, 255, 255, 255, 255)

                store.state.planViewer.loadExtension('labels3dExt');
                store.state.planViewer.loadExtension('Plan2DExtension').then(ex => {
                    ex.drawDirection2D();
                });

                let callback = store.state.load2dViewerCallback;

                if (callback) {
                    callback();
                    store.commit("setLoad2dViewerCallback", null);
                }

                store.state.planViewer.loadExtension('MeasurementExtension').then(ex => ex.isMeasuring2D = true);
                store.state.planViewer.navigation.setReverseZoomDirection(true);
            });

        }, errorMsg => console.error);
    });
}

export function openAttachment(attachment) {
    if (!attachment?.url) {
        store.dispatch("alert_Forge", {
            message: 'NO valid attachment to open.'
        })
        return;
    }

    let ext = attachment.name.split(/[#?]/)[0].split('.').pop().trim().toLowerCase();

    if (isImageViewer(ext) || isPdfViewer(ext)) {
        if (isImageViewer(ext)) store.state.isMarkupImage = true;
        else store.state.isMarkupImage = false;

        if (!getViewPageDoc()) {
            store.state.mainApp.openViewPageWithType('doc');
        }
        else {
            store.state.mainApp.showViewPageWithType('doc');
        }

        setTimeout(() => {
            launchPDFViewer(attachment);
        }, 100);
    } else if (isVideoViewer(ext)) {
        if (!getViewPageVideo()) {
            store.state.mainApp.openViewPageWithType('vid');
        }
        else {
            store.state.mainApp.showViewPageWithType('vid');
        }

        store.commit('setActiveVideoSrc', attachment.url);
    } else if (isOfficeViewer(ext)) {
        if (!getViewPageOfficeDoc()) {
            store.state.mainApp.openViewPageWithType('office-doc');
        }
        else {
            store.state.mainApp.showViewPageWithType('office-doc');
        }
        store.commit('SET_OFFICE_DOCUMENT_URL', encodeURIComponent(attachment.url));
    } else {
        window.open(attachment.url, '_blank').focus();
    }

    store.commit('setActiveAttachment', attachment);
}

export function isOfficeViewer(ext) {
    return (/( xls|xlsx|xlsm|docx|doc|pptx|ppt)$/i).test(ext);
}

export function isVideoViewer(ext) {
    return (/(mp4|webm|ogg)$/i).test(ext);
}

export function isImageViewer(ext) {
    return (/(png|jpg)$/i).test(ext);
}

export function isPdfViewer(ext) {
    return (/(pdf)$/i).test(ext);
}

export function stopForge() {
    disposeForgeViewers();
    store.state.adminAppContainer = null;
    store.state.mainApp = null;
    store.state.markupsApp = null;
}
export function dispose3DViewer() {
    store.commit('hideThumbnailPopup', '3d');
    store.commit('setIsTreeLoaded', false);

    if (store.state.viewer) {
        store.state.viewer.finish();
        store.state.viewer = null;
    }
}
export function dispose2DViewer() {
    store.commit('hideThumbnailPopup', '2d');

    if (store.state.planViewer) {
        store.state.planViewer.finish();
        store.state.planViewer = null;
    }
}
export function disposeDocViewer() {
    if (store.state.pdfviewer) {
        store.state.pdfviewer.finish();
        store.state.pdfviewer = null;
    }
    store.commit('setActiveAttachment', null)
    store.commit('setActiveAttachmentPage', 0)
    store.commit('setActiveAttachmentPagesCount', 0)
}
export function disposeForgeViewers() {
    dispose3DViewer();
    dispose2DViewer();
    disposeDocViewer();
    if (store.state.forgeService && store.state.forgeService.panoramaViewer)
        store.state.forgeService.panoramaViewer.destroy();

    if (store.state.mainApp && getMarkupsComponent() && getMarkupsComponent().markupViewer) {
        getMarkupsComponent().markupViewer.finish();
        getMarkupsComponent().markupViewer = null;
    }
    Autodesk.Viewing.shutdown();
}
var startedPanning = false;
export function onDocumentLoadSuccess(doc) {
    var viewables = doc.getRoot().getDefaultGeometry();
    const options = {
        // applyScaling: { to: 'm' },
    };
    if (store.state.dbidsToLoad) {
        options.ids = store.state.dbidsToLoad;
        options.useConsolidation = false;
    }
    store.state.viewer.loadDocumentNode(doc, viewables, options).then(i => {

        store.dispatch('SET_VIEWER_DISPLAY_DEFAULT_PREFERENCES');

        store.state.globalOffset = store.state.viewer.model.getGlobalOffset();
        store.state.unitScale = store.state.viewer.model.getUnitScale();

        var walkEx = store.state.viewer.getExtension('Autodesk.BimWalk');
        if (walkEx)
            walkEx.tool.navigator.enableGravity(false);
        store.state.viewer.loadExtension('Autodesk.Section').then(ex => {
            setTimeout(() => {
                $('#toolbar-sectionTool').css('display', 'none');
            }, 100);
        });
        store.state.viewer.loadExtension('labels3dExt');
        store.state.viewer.loadExtension('CustomContextMenuExtension');
        store.state.viewer.loadExtension('Mapping2d_3dExtension');

        //update 3d icons in 360 viewer in case if opened
        store.state.forgeService.updateTagsAnnotationsInPanoViewer();
        store.state.forgeService.update360ImagesHotspots();
        store.state.forgeService.update3dIconsInAllViews();

        let current = store.getters["getDisplayUnit"];
        let modelUnit = store.state.viewer.model.getUnitString();

        /* 
        ** Admin side
        > We Stored any model displayUnit in the admin section when the user opens it in the viewer (launchViewer3D => admin-container) to :
            1- Show the 3D model.
            2- Mapping 2D plan model with 3D model.

        ** User side
        > We got the displayUnit for the selected model from DB in the fetchAllForgeModel request.

        > There are 2 cases where displayUnit needs to update : 
            1- The user does not open  any 3D viewer in the admin section, so displayUnit will be null. 
            2- The displayUnit is not the Model displayUnit.
        */
        if (!current || modelUnit != current) {
            store.dispatch({
                type: "updateDisplayUnit",
                displayUnit: modelUnit
            })
        }

    });

    let pointerEnd = (evt) => {
        if (!store.state.forgeService)
            return;

        let isPickingTag = store.state.isPickingTag;
        let isPickingSubTag = store.state.isPickingSubTag;
        let isPickingCropOrigin = store.state.isPickingCropOrigin;
        let isPickingPin = store.state.isPickingPin;

        if (isPickingTag || isPickingCropOrigin || isPickingSubTag || isPickingPin) {
            var hitTest = store.state.viewer.clientToWorld(evt.offsetX, evt.offsetY, false);
            let point = null;
            let pointOnModel = null;
            if (hitTest && hitTest.point)
                pointOnModel = hitTest.point;
            let pointOnPointCloud = store.state.forgeService.getMainExtension().pickNearestPointCloudPoint(evt);
            let cameraPt = store.state.viewer.navigation.getPosition();
            if (!pointOnModel && !pointOnPointCloud) {
                store.dispatch({ type: "alert_Forge", message: "Please pick point on any element." })
                if (isPickingPin)
                    store.commit('setIsPickingPin', false);
                return;
            } else if (pointOnModel && pointOnPointCloud)
                point = cameraPt.distanceTo(pointOnModel) < cameraPt.distanceTo(pointOnPointCloud) ? pointOnModel : pointOnPointCloud;
            else if (pointOnModel)
                point = pointOnModel;
            else
                point = pointOnPointCloud;

            let viewerPt = point.clone();
            //to give Forge time to update selection
            setTimeout(() => {
                let selection = store.state.viewer.getSelection();
                if (isPickingTag && selection.length > 0) {
                    store.state.forgeService.createTagFromSelection();
                } else if (isPickingTag) {
                    store.commit('setIsPickingTag', false)
                    let globalPt = store.state.forgeService.view3dToWorld(point);
                    store.state.forgeService.addNewTag('3d', globalPt, null, true);
                } else if (isPickingCropOrigin) {
                    store.state.forgeService.crop3D(viewerPt);
                } else if (isPickingSubTag) {
                    let globalPt = store.state.forgeService.view3dToWorld(point)
                    store.state.forgeService.addSubInspection(globalPt);
                } else if (isPickingPin) {
                    store.state.pinnedPoint3d = point;
                    store.state.forgeService.getMainExtension().updatePinPoint();
                    store.commit('setIsPickingPin', false);
                }
            }, 100);

        }

        var extension = store.state.forgeService.getMainExtension();
        if (extension == null || !store.state.areViewsLocked || !store.state.selectedImage || !store.state.forgeService.panoramaViewer || !startedPanning)
            return;
        let bimEx = store.state.viewer.getExtension('Autodesk.BimWalk')
        if (bimEx)
            bimEx.deactivate();
        startedPanning = false;
    }

    let pointerStart = (evt) => {
        store.state.viewerMouseDownEvent = evt;

        if (evt.which == 2 && store.state.areViewsLocked) evt.preventDefault();

        TurnViewerLockOff();

        if (evt.which == 3) store.state.mouseDownHitTest = store.state.viewer.clientToWorld(evt.offsetX, evt.offsetY, false);

        var extension = store.state.forgeService.getMainExtension();
        if (extension == null || !store.state.areViewsLocked || !store.state.selectedImage || !store.state.forgeService.panoramaViewer)
            return;
        let bimEx = store.state.viewer.getExtension('Autodesk.BimWalk')
        if (bimEx) {
            bimEx.activate();
            setTimeout(() => {
                $('.c-bimwalk-tooltip__actions #dontRemind').click()
            }, 50)
        }
        startedPanning = true;
    }

    store.state.viewer.canvas.addEventListener('touchend', pointerEnd);
    store.state.viewer.canvas.addEventListener('touchstart', pointerStart);
    store.state.viewer.canvas.addEventListener('mouseup', pointerEnd);
    store.state.viewer.canvas.addEventListener('mousedown', pointerStart);
    let isFirefox = (/Firefox/i.test(navigator.userAgent));
    var mousewheelevt = isFirefox ? "DOMMouseScroll" : "mousewheel";
    store.state.viewer.canvas.addEventListener(mousewheelevt, (evt) => {
        // if(store.state.mainApp.showComparasionTool)
        //     return;
        var extension = store.state.forgeService.getMainExtension();
        if (extension == null || !store.state.areViewsLocked || !store.state.selectedImage || !store.state.forgeService.panoramaViewer)
            return;
        if (!store.state.viewer.getExtension('Cropping3DExtension')?.croppingOn)
            store.state.viewer.navigation.setIsLocked(true);

        store.state.viewer.getExtension('Autodesk.BimWalk').deactivate();
        let delta = isFirefox ? evt.detail : evt.wheelDelta;
        var isZooming = delta > 0;
        // var forgeFocalLength = store.state.viewer.navigation.getFocalLength();
        // if (isZooming) {
        //     forgeFocalLength -= 5;
        //     if (forgeFocalLength < 10)
        //         forgeFocalLength = 10;
        // } else {
        //     forgeFocalLength += 5;
        //     if (forgeFocalLength > 25)
        //         forgeFocalLength = 25;
        // }
        // store.state.viewer.navigation.setFocalLength(forgeFocalLength)

        // var ratio = (25.0 - forgeFocalLength) / 15.0;
        // var newFOV = 50 + 70 * ratio;
        // store.state.forgeService.panoramaViewer.lookAt(store.state.forgeService.panoramaViewer.getPitch(),store.state.forgeService.panoramaViewer.getYaw(),newFOV,0);

        ///===== Old way to Zoom =====///
        // var fov = store.state.viewer.getFOV();

        // if (isZooming) {
        //     fov -= 5;
        //     if (fov < store.state.viewer.navigation.getFovMin())
        //         fov = store.state.viewer.navigation.getFovMin();
        // } else {
        //     fov += 5;
        //     if (fov > store.state.viewer.navigation.getFovMax())
        //         fov = store.state.viewer.navigation.getFovMax();
        // }

        // if(store.state.areViewsLocked) {
        //     let newFOV = fov;

        //     if (store.state.mainApp.localShowComparasionTool) newFOV = fov / 0.6;

        //     let canApply = this.fovOnPanoBounds(newFOV);

        //     if (canApply) {
        //         store.state.viewer.navigation.setFocalLength(store.state.viewer.navigation.fov2fl(fov));


        //         store.state.forgeService.panoramaViewer.setHfov(newFOV,false)
        //     }
        // } else {
        //     store.state.viewer.navigation.setFocalLength(store.state.viewer.navigation.fov2fl(fov));
        // }
        ///===============================================///

        if (store.state.areViewsLocked) {
            // 3d is connected to 360.
            let currentHFov = store.state.forgeService.panoramaViewer.getHfov();

            let newHFov = currentHFov;

            if (isZooming) newHFov -= 5;
            else newHFov += 5;

            let canApply = store.state.forgeService.isHFovInBounds(newHFov);

            if (canApply) {
                store.state.forgeService.panoramaViewer.setHfov(newHFov, false);
                store.state.forgeService.mapPanoramaHFovTo3dVHov();
            }
        } else {
            // 3d only or 360 is not connected.
            var vFov = store.state.viewer.navigation.getVerticalFov();

            if (isZooming) {
                vFov -= 5;
                if (vFov < store.state.viewer.navigation.getFovMin()) vFov = store.state.viewer.navigation.getFovMin();
            } else {
                vFov += 5;
                if (vFov > store.state.viewer.navigation.getFovMax()) vFov = store.state.viewer.navigation.getFovMax();
            }

            store.state.viewer.navigation.setVerticalFov(vFov);
        }
    });

}
export function TurnViewerLockOff() {
    if (!store.state.viewer)
        return;
    if (!store.state.viewer.getExtension('Cropping3DExtension')?.croppingOn
        && !store.state.viewer.getExtension('ScaffoldBoxExtension')?.draggingPoint)// && !store.state.mainApp.showComparasionTool)
        store.state.viewer.navigation.setIsLocked(false);
}
export function onDocumentLoadFailure(viewerErrorCode) {
    console.error('onDocumentLoadFailure() - errorCode:' + viewerErrorCode);
}

//save/load whole Forge page state
export function getStateId(callback) {
    let cropping3DExtension = store.state.viewer ? store.state.viewer.getExtension('Cropping3DExtension') : null;
    let state = {
        assetId: store.state.assetId,
        isView1Visible: store.state.mainApp.isView1Visible,
        isView2Visible: store.state.mainApp.isView2Visible,
        isView3Visible: store.state.mainApp.isView3Visible,
        isView4Visible: store.state.mainApp.isView4Visible,
        isLeftMenuPinned: store.state.mainApp.isLeftMenuPinned,
        isTabShown: store.state.isTabShown,
        selectedTab: store.state.selectedTab,
        view1Type: store.state.mainApp.view1Type,
        view2Type: store.state.mainApp.view2Type,
        view3Type: store.state.mainApp.view3Type,
        view4Type: store.state.mainApp.view4Type,
        leftSideViewersWidth: document.getElementById('left-side-viewers').style.width,
        rightSideViewersWidth: document.getElementById('right-side-viewers').style.width,
        topleftViewerHeight: document.getElementById('topleft-viewer').style.height,
        bottomleftViewerHeight: document.getElementById('bottomleft-viewer').style.height,
        topRightViewerHeight: document.getElementById('topright-viewer').style.height,
        bottomRightViewerHeight: document.getElementById('bottomright-viewer').style.height,
        showComparasionTool: store.state.mainApp.localShowComparasionTool,
        panoSeparatorLeft: store.state.mainApp.panoSeparatorLeft,
        viewCompareWidth: store.state.mainApp.viewCompareWidth,
        container360Opacity: getViewPage360() ? getViewPage360().containerOpacity : 0,
        showActivityManager: store.getters['getIsRealityActivityManagerShown'],

        isLockedViewer3DAndPano: store.state.selectedImage != null && store.state.selectedImage.isLocked,
        images360ShownProjects: store.state.projects.filter(o => o.images.some(i => i.isVisibleInViewers)).map(o => o.name),
        viewer3DSettings: !store.state.viewer ? null : {
            urn: store.state.mainUrn,
            shownPointCloudsUrls: store.state.pointClouds.filter(o => o.isShown).map(o => o.url),
            shownSmallModelsUrns: store.state.uploadedModels.filter(o => o.isShown).map(o => o.urn),
            viewerState: store.state.viewer.getState(),
            measuringLine: !store.state.forgeService.getMeasureExtensionInViewer3D() || !store.state.forgeService.getMeasureExtensionInViewer3D().dimensionLine ? null : {
                start: store.state.forgeService.getMeasureExtensionInViewer3D().dimensionLine.v1,
                end: store.state.forgeService.getMeasureExtensionInViewer3D().dimensionLine.v2
            },
            cropBox: cropping3DExtension && cropping3DExtension.croppingOn && cropping3DExtension.cropBox ? cropping3DExtension.cropBox : null,
            cropLevels: store.state.levels.filter(o => o.isCropped).map(o => o.name),
        },
        viewer2DSettings: !getViewPage2d() || !store.state.planViewer ? null : {
            urn: store.state.selectedLevel ? store.state.selectedLevel.planUrn : null,
            measuredArea: store.state.forgeService.getDrawPointsExtension().areaPoints,
            viewerState: store.state.planViewer ? store.state.planViewer.getState() : null,
            measuringLine: !store.state.forgeService.getMeasureExtensionInViewer2D() || !store.state.forgeService.getMeasureExtensionInViewer2D().dimensionLine ? null : {
                start: store.state.forgeService.getMeasureExtensionInViewer2D().dimensionLine.v1,
                end: store.state.forgeService.getMeasureExtensionInViewer2D().dimensionLine.v2
            },
        },
        panoViewerSettings: !getViewPage360() || !store.state.selectedImage ? null : {
            areViewsLocked: store.state.areViewsLocked,
            fov: store.state.forgeService.panoramaViewer.getHfov(),
            yaw: store.state.forgeService.panoramaViewer.getYaw(),
            pitch: store.state.forgeService.panoramaViewer.getPitch(),
            image: store.state.selectedImage,
            measuringLineStart: store.state.mainApp.panoMeasureStart ? store.state.mainApp.panoMeasureStart : null,
            measuringLineEnd: store.state.mainApp.panoMeasureEnd ? store.state.mainApp.panoMeasureEnd : null,
        },
        markupsViewerSettings: !getMarkupsComponent().markupViewer ? null : {
            annotationGuid: getMarkupsComponent().annotation.id,
            urn: getMarkupsComponent().markup ? getMarkupsComponent().markup.urn : null,
            pageId: getMarkupsComponent().currentPageId,
            viewerState: getMarkupsComponent().markupViewer ? getMarkupsComponent().markupViewer.getState() : null,
        }
    };
    saveState(state, callback);
}
export function restoreState(id) {
    store.state.mainApp.restoreState(id);
}
export function drawMeasureLine(measureLine, measureExtension) {
    let start = new THREE.Vector3(measureLine.start.x, measureLine.start.y, measureLine.start.z);
    let end = new THREE.Vector3(measureLine.end.x, measureLine.end.y, measureLine.end.z);
    measureExtension.dimensionLine = new THREE.LineCurve(start, end);
    measureExtension.drawDimensionLine();
}
export function restoreStateToViewer3d() {
    var state = store.state.fetchedState;
    store.state.viewer.restoreState(state.viewer3DSettings.viewerState, false, true);
    store.state.projects.filter(o => state.images360ShownProjects.includes(o.name)).forEach(o => o.setAllImagesVisibleInViewers(true));
    if (state.viewer3DSettings.measuringLine) {
        let measure3DEx = store.state.forgeService.getMeasureExtensionInViewer3D();
        drawMeasureLine(state.viewer3DSettings.measuringLine, measure3DEx);
    }
    if (state.viewer3DSettings.cropBox) {
        let cropping3DExtension = store.state.viewer.getExtension('Cropping3DExtension');
        cropping3DExtension.croppingOn = true;
        cropping3DExtension.cropBox = Object.assign(new THREE.Box3(), state.viewer3DSettings.cropBox);
        cropping3DExtension.toggleCropbox(true);
    }
    if (state.viewer3DSettings.cropLevels) {
        let levs = store.state.levels.find(o => state.viewer3DSettings.cropLevels.includes(o.name));
        store.state.forgeService.cropLevelIn3D(levs, false);
    }
    state.viewer3DSettings.shownSmallModelsUrns.forEach(urn => {
        let model = store.state.uploadedModels.find(o => o.urn == urn);
        if (model)
            store.state.forgeService.toggleShowingModel(model);
    });
    state.viewer3DSettings.shownPointCloudsUrls.forEach(url => {
        let pc = store.state.pointClouds.find(o => o.url == url);
        if (pc) {
            pc.isShown = !pc.isShown;
            var mainExtension = store.state.forgeService.getMainExtension();
            mainExtension.showPointCloud(pc.name, pc.isShown, pc.url);
        }
    });
    store.state.areViewsLocked = !state.panoViewerSettings ? false : state.panoViewerSettings.areViewsLocked;

    store.state.fetchedState = null;
}

//markups viewer
export function launchPDFViewer(attachment) {
    store.state.pdfViewerLoaded = false;
    if (!attachment.url)
        return;
    if (store.state.pdfviewer)
        store.state.pdfviewer.finish();

    var pageNumber = 1;
    store.commit('setActiveAttachmentPage', pageNumber);
    Autodesk.Viewing.Initializer({}, () => {
        store.state.pdfviewer = new Autodesk.Viewing.Private.GuiViewer3D(document.getElementById('docViewer'), { extensions: ['Autodesk.DocumentBrowser'] });
        store.state.pdfviewer.setTheme("light-theme");
        store.state.pdfviewer.start();
        $('.forge-spinner img').attr('src', require('@/images/RealityLoader.png'));
        store.state.pdfviewer.loadExtension('Autodesk.PDF').then(() => {
            var pdfUrl = store.state.isMarkupImage ? './assets/files/emptyPage.pdf' : attachment.url;
            store.state.pdfviewer.loadModel(pdfUrl, {
                page: pageNumber
            },
                () => {
                    if (store.getters['getIsFlutterRunning'])
                        onMarkupViewerLoaded();
                    //draw image on plane if image
                    if (store.state.isMarkupImage)
                        drawImageOnPlane(attachment.url, store.state.pdfviewer)
                    $('#docViewer #guiviewer3d-toolbar').css('display', 'none');

                    var pagesCount = getViewerCurrentPdfPagesCount(store.state.pdfviewer);
                    store.commit('setActiveAttachmentPagesCount', pagesCount);

                    //Load Markups into doc Viewer
                    let markupText = '';
                    let markupJson = {};
                    var activeAttachment = store.getters['getActiveAttachment'];
                    if (activeAttachment.pagesMarkups) {
                        let page = activeAttachment.pagesMarkups.find(o => o.pageId == 1);
                        if (page && page.markupText) {
                            markupText = page.markupText;
                            markupJson = JSON.parse(markupText);
                        }
                        if (page?.rotation) {
                            rotateViewerCamera(store.state.pdfviewer, page?.rotation);
                        }
                        // remove previous links if any...
                        $(store.state.pdfviewer.container).find('.markup-link').remove();

                        if (page && page.links) {
                            let highlightedId = store.getters['getTagIdToHighlight'];
                            page.links.forEach((link) => {
                                let metadata = JSON.parse(link.metadata);
                                let classes = highlightedId && metadata?.id == highlightedId ? 'markup-link selected-markup-link' : 'markup-link'
                                var iconOptions = {
                                    position: link.position,
                                    width: link.width,
                                    height: link.height,
                                    rotation: link.rotation,
                                    differences: null,
                                    title: link.name,
                                    id: link.id ?? link.linkedAttachmentId,
                                    className: classes,
                                    forgeViewer: store.state.pdfviewer,
                                    metadata: metadata?.id ?? "",
                                    onClick: (e) => {
                                        e.stopPropagation();
                                        e.preventDefault();
                                        var element = e.srcElement;
                                        link.element = element;
                                        store.commit('setPreviewingLinkElement', element);
                                        store.commit('setPdfViewerPreviewingLink', link);
                                    },
                                    addContent: true,
                                    removeTildeSign: true
                                }
                                store.state.forgeService.create3DIconToViewer(iconOptions);
                            });
                            store.commit('setTagIdToHighlight', null);
                        }
                    }
                    updateMarkupsOnViewer(store.state.pdfviewer, markupJson, "Layer_1");
                }
            );
            store.state.pdfviewer.navigation.setReverseZoomDirection(true);
            store.state.pdfViewerLoaded = true;
        });
    });
}
export async function drawImageOnPlane(url, pdfviewer) {
    var base64 = await getBase64FromUrl(url);
    drawImage64OnPlane(base64, pdfviewer)
}

export function drawImage64OnPlane(base64, pdfviewer) {
    pdfviewer.setBackgroundColor(255, 255, 255, 255, 255, 255)
    if (!pdfviewer.overlays.hasScene('custom-scene'))
        pdfviewer.overlays.addScene('custom-scene');

    pdfviewer.overlays.clearScene();
    if (pdfviewer.imageMesh) {
        pdfviewer.overlays.removeMesh(pdfviewer.imageMesh, 'custom-scene');
        pdfviewer.imageMesh.geometry.dispose();
        pdfviewer.imageMesh.material.map.dispose();
        pdfviewer.imageMesh.material.dispose();
        pdfviewer.imageMesh = null;
    }

    const image = new Image();
    image.onload = () => {
        var texture = THREE.ImageUtils.loadTexture(image.src);
        texture.needsUpdate = true;
        texture.minFilter = THREE.NearestFilter

        // if (image.width < image.height)
        //     texture.repeat.setX(image.height / image.width)
        // else
        //     texture.repeat.setY(image.width / image.height)

        let material = new THREE.MeshBasicMaterial({ map: texture });
        var width = 8;
        var height = width * image.height / image.width;
        const geometry = new THREE.PlaneBufferGeometry(width, height);

        var mesh = new THREE.Mesh(geometry, material);
        mesh.position.set(4, height / 2, .001);

        pdfviewer.overlays.addMesh(mesh, 'custom-scene');
        pdfviewer.imageMesh = mesh

        let min = new THREE.Vector3(0, 0, 0);
        let max = new THREE.Vector3(width, height, 0);
        var box = new THREE.Box3(min, max);
        pdfviewer.navigation.fitBounds(true, box, false, true);
        store.state.markupImageWidth = width;
        store.state.markupImageHeight = height;

        pdfviewer.impl.invalidate(true, true, true);
    };
    image.src = base64;
}
//https://stackoverflow.com/questions/22172604/convert-image-from-url-to-base64
export async function getBase64FromUrl(url) {
    const data = await fetch(url);
    const blob = await data.blob();
    return new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = () => {
            const base64data = reader.result;
            resolve(base64data);
        }
    });
}
export function updateMarkupsOnViewer(viewer = store.state.pdfviewer, jsonData, layerName = "Layer_1") {
    viewer.loadExtension("Autodesk.Viewing.MarkupsCore")
        .then(function (extension) {
            //Enable stamp markup
            var promise = new Promise((resolve) => {
                // var rootPath = (appConfig.debugMode ? '../../' : appConfig.UI_URL);
                // var rootPath = '@/extensions/StampExtension.js'

                require(`@/extensions/StampExtension.js`);

                let ext = viewer.getExtension('StampExtension');                
                if (ext) {
                    resolve();
                } else {
                    viewer.loadExtension('StampExtension').then(resolve);
                }
            })
            promise.then(() => {
                //Just to create a new markup layer with LayerName
                extension.enterEditMode(); //Enforce Creation of ext.editModeSvgLayerNode to nest new layer in
                extension.leaveEditMode(); //Leave edit mode to allow creation of new layer
                extension.loadMarkups('', layerName); //Enforce create new markups layer

                extension.enterEditMode(layerName);
                extension.clear();
                extension.leaveEditMode();

                var editor = extension;
                var avemc = Autodesk.Viewing.Extensions.Markups.Core
                const stampExtensionJs = require('./../../extensions/StampExtension');
                for (var i = 0; i < jsonData.length; i++) {
                    var currentMarkup = jsonData[i];
                    var createMarkup = null;
                    var id = currentMarkup.id;
                    var tail = currentMarkup.tail;
                    var head = currentMarkup.head;
                    var style = currentMarkup.style;
                    var size = currentMarkup.size;
                    var text = currentMarkup.text;
                    var position = currentMarkup.position;
                    var rotation = currentMarkup.rotation;
                    var closed = currentMarkup.closed;
                    var locations = currentMarkup.locations;

                    switch (jsonData[i].type) {
                        case "arrow":
                            createMarkup = new avemc.CreateArrow(editor, id, tail, head, style);
                            break;
                        case "label":
                            createMarkup = new avemc.CreateText(editor, id, position, size, text, style);
                            break;
                        case "ellipse":
                            createMarkup = new avemc.CreateCircle(editor, id, position, size, rotation, style);
                            break;
                        case "cloud":
                            createMarkup = new avemc.CreateCloud(editor, id, position, size, rotation, style);
                            break;
                        case "callout":
                            createMarkup = new avemc.CreateCallout(editor, id, position, size, rotation, style);
                            break;
                        case "rectangle":
                            createMarkup = new avemc.CreateRectangle(editor, id, position, size, rotation, style);
                            break;
                        case "freehand":
                            createMarkup = new avemc.CreateFreehand(editor, id, position, size, rotation, locations, style);
                            break;
                        case "highlight":
                            createMarkup = new avemc.CreateHighlight(editor, id, position, size, rotation, locations, style);
                            break;
                        case "polyline":
                            createMarkup = new avemc.CreatePolyline(editor, id, position, size, rotation, locations, style, closed);
                            break;
                        case "polycloud":
                            createMarkup = new avemc.CreatePolycloud(editor, id, position, size, rotation, locations, style, closed);
                            break;
                        case "stamp":
                            var customSVG = avemc.Utils.stringToSvgNode(currentMarkup.svg)
                            createMarkup = new stampExtensionJs.StampCreateAction(editor, id, position, size, rotation, style, customSVG)
                            break;
                    }
                    if (createMarkup) {
                        createMarkup.addToHistory = false;
                        extension.enterEditMode(layerName);
                        createMarkup.execute();
                    }
                }
                extension.leaveEditMode();
            })

        });

    viewer.addEventListener(Autodesk.Viewing.CAMERA_CHANGE_EVENT, () => {
        store.state.forgeService.updateLabelsPositionsByClassName("markup-link", viewer)
        store.state.forgeService.updateLabelsPositionsByClassName('markups-link-preview-popup-container', viewer);
    });
}
export function pdfViewerOpenPageByNumber(pageNumber) {

    if (!pageNumber || isNaN(pageNumber) || pageNumber < 1) {
        return;
    }

    store.commit('setActiveAttachmentPage', pageNumber);
    var activeAttachment = store.state.MARKUPS.activeAttachment;
    var pdfUrl = activeAttachment.url;
    var pdfViewer = store.state.pdfviewer;
    if (!pdfUrl || !pdfViewer)
        return;

    if (pdfViewer.model) {
        pdfViewer.unloadModel();
    }
    pdfViewer.loadedExtensions['Autodesk.PDF'].load().then(() => {
        var url = store.state.isMarkupImage ? './assets/files/emptyPage.pdf' : pdfUrl;
        pdfViewer.loadModel(url, {
            page: pageNumber
        }, (doc) => {

            if (store.getters['getIsFlutterRunning'])
                onMarkupViewerLoaded();

            //draw image on plane if image
            if (store.state.isMarkupImage)
                drawImageOnPlane(pdfUrl, pdfViewer)

            let page = activeAttachment.pagesMarkups.find(o => o.pageId == pageNumber);
            if (page?.rotation) {
                rotateViewerCamera(pdfViewer, page?.rotation);
            }
            //try clearing markups anyways
            var extension = pdfViewer.loadedExtensions['Autodesk.Viewing.MarkupsCore'];
            extension.enterEditMode();
            extension.clear();
            extension.unloadMarkupsAllLayers();
            extension.leaveEditMode();

            // remove previous links if any...
            $(pdfViewer.container).find('.markup-link').remove();

            if (page) {
                if (page.links) {
                    page.links.forEach((link) => {
                        var iconOptions = {
                            position: link.position,
                            width: link.width,
                            height: link.height,
                            rotation: link.rotation,
                            differences: null,
                            title: link.name,
                            id: link.id ?? link.linkedAttachmentId,
                            className: "markup-link",
                            forgeViewer: store.state.pdfviewer,
                            onClick: (e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                var element = e.srcElement;
                                link.element = element;
                                store.commit('setPreviewingLinkElement', element);
                                store.commit('setPdfViewerPreviewingLink', link);
                            },
                            addContent: true,
                            removeTildeSign: true
                        }
                        store.state.forgeService.create3DIconToViewer(iconOptions);
                    });
                }

                if (page.markupText) {
                    var markupJson = JSON.parse(page.markupText);
                    if (markupJson) {
                        updateMarkupsOnViewer(pdfViewer, markupJson, "Layer_1");
                    }
                }
            } else {
                // remove previous links if any...
                $(pdfViewer.container).find('label.markup-link').remove();
            }
        });
    });

}

const onViewerLoaded_Flutter = window.onViewerLoaded_Flutter;
export function onMarkupViewerLoaded() {
    try {
        onViewerLoaded_Flutter?.postMessage('test');
    } catch (error) {
        console.error(error)
    }
}

const onSave_Flutter = window.onSave_Flutter;
export function onSaveFlutter() {
    try {
        onSave_Flutter?.postMessage('markups saved');
    } catch (error) {
        console.error(error)
    }
}

const onEditModeLeave_Flutter = window.onEditModeLeave_Flutter;
export function onEditModeLeaveFlutter() {
    try {
        onEditModeLeave_Flutter?.postMessage('onEditModeLeave');
    } catch (error) {
        console.error(error)
    }
}

const onHistoryChanged_Flutter = window.onHistoryChanged_Flutter;
export function onHistoryChangedFlutter(message) {
    try {
        onHistoryChanged_Flutter?.postMessage(message); //undo and redo status
    } catch (error) {
        console.error(error)
    }
}

const onMarkupLinkClicked_Flutter = window.onMarkupLinkClicked_Flutter;
export function onMarkupLinkClickedFlutter(link) {
    try {
        let metadata = JSON.parse(link.metadata);

        if (!metadata?.id) return 

        onMarkupLinkClicked_Flutter?.postMessage(metadata.id);
    } catch (error) {
        console.error(error)
    }
}

export function getViewPage360() {
    return store.state.mainApp.$children.filter(o => o.$vnode.tag.includes('PageView')).find(o => o.view_type == '360');
}

export function getViewPage3D() {
    return store.state.mainApp.$children.filter(o => o.$vnode.tag.includes('PageView')).find(o => o.view_type == '3d');
}

export function getViewPage2d() {
    return store.state.mainApp.$children.filter(o => o.$vnode.tag.includes('PageView')).find(o => o.view_type == '2d');
}

export function getViewPageDoc() {
    return store.state.mainApp.$children.filter(o => o.$vnode.tag.includes('PageView')).find(o => o.view_type == 'doc');
}

export function getViewPageOfficeDoc() {
    return store.state.mainApp.$children.filter(o => o.$vnode.tag.includes('PageView')).find(o => o.view_type == 'office-doc');
}

export function getViewPageVideo() {
    return store.state.mainApp.$children.filter(o => o.$vnode.tag.includes('PageView')).find(o => o.view_type == 'vid');
}

export function getMessagePopup() {
    if (store.state.mainApp)
        return store.state.mainApp.$children.find(o => o.$vnode.tag.includes('MessagePopup'));
    else
        return store.state.adminAppContainer.$children.find(o => o.$vnode.tag.includes('MessagePopup'));
}

export function getMarkupsComponent() {
    if (store.state.mainApp)
        return store.state.mainApp.$children.find(o => o.$vnode.tag.includes('markups-popup'));
    else
        return store.state.adminApp.$children[0].$children.find(o => o.$vnode.tag.includes('markups-popup'));
}
export function showCopiedTextPopup(text, warning) {
    let component = store.state.mainApp.$children.find(o => o.$vnode.tag.includes('copied-text'));
    component.show(text, warning);
}

export function toggleExpandComponent(component) {
    if (!component) return;
    var result = !component.isExpanded;
    store.state.adminAppContainer?.$children?.forEach(o => o.isExpanded = false);
    component.isExpanded = result;
}

export function getEditLevelComponent() {
    return store.state.adminAppContainer.$children.find(o => o.$vnode.tag.includes('EditLevel'));
}